module.exports = __webpack_public_path__ + "images/fd22ead87efc1c2b3b47753cbe670baa.png";